import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import BadgeExpertise from "../../components/BadgeExpertise";

import "../../css/views/FicheProjet.css";
import imageGradient2 from "../../images/gradient-2.jpg";
import imageChevronLtr from "../../images/chevron-ltr.png";

import data from "./project-details";

export default class FicheProjet extends Component {
  constructor(props) {
    super(props);
    this.state = { contentPage: data[props.match.params.name] };
    
    this.props.history.listen((_route, action) => {
      if(action === 'POP') {
        this.goTo(props.match.params.name)
      }
    })
  }

  render() {
    const { contentPage } = this.state;

    if (!contentPage) {
      return this.projectNotFound(this.props.match.params.name);
    }

    const {
      title,
      subtitle,
      description,
      technologies,
      expertises,
      page,
      previous,
      next,
      img,
      objectives,
      objectives2
    } = contentPage;
    return (
      <div className="fiche-projet inner-content-page">
        <section className="hero-unit">
          <div>
            <img src={imageGradient2} alt="" />
            <div>
              {title}
              <br />
              <small>{subtitle}</small>
            </div>
          </div>
          <div>
            <small>
              <p>
                <small>{description}</small>
              </p>
              {this.getExperitises(expertises)}
              {this.getTechnologies(technologies)}
            </small>
          </div>
        </section>

        <section className="page-content">
          {page ? React.createElement(page, { img, objectives, objectives2 }) : null}
        </section>

        <section className="bloc-showcase prev-next">
          {this.getBlocCta(previous)}
          {this.getBlocCta(next)}
        </section>
      </div>
    );
  }

  goTo(link) {
    this.setState({
      contentPage: data[link]
    });
  }

  getExperitises(expertises) {
    if (expertises) {
      return (
        <div>
          <p>
            <strong>Nos expertises :</strong>
          </p>
          <div className="expertises">
            {expertises.map((expertise, index) => {
              return (
                <BadgeExpertise
                  key={index}
                  src={expertise.src}
                  title={expertise.pole}
                />
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  }

  getTechnologies(technologies) {
    if (technologies) {
      return (
        <div>
          <p>
            <strong>Technologies :</strong>
          </p>
          <p className="text-detail">{technologies.join(", ")}</p>
        </div>
      );
    }
    return null;
  }

  getBlocCta(object) {
    if (object) {
      return (
        <div className="bloc-cta">
          <img src={object.src} alt={object.link} />
          <div>
            <h4>{data[object.link].title}</h4>
            <h5>{data[object.link].summary}</h5>
            <NavLink
              to={"/projet/" + object.link}
              onClick={() => this.goTo(object.link)}
              className="btn btn-white btn-morph"
            >
              Découvrir le projet
            </NavLink>
          </div>
        </div>
      );
    }
    return null;
  }

  projectNotFound(name) {
    return (
      <div className="fiche-projet not-found inner-content-page">
        <section className="content-page">
          <section className="bloc-texte">
            <h3>
              Oups ! Nous n'avons pas trouvé d'information au sujet de{" "}
              <strong>{name}</strong> !
            </h3>
            <NavLink to="/projets">
              <a className="btn btn-black">
                Voir la liste des projets <img src={imageChevronLtr} alt="" />
              </a>
            </NavLink>
          </section>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/projet/FicheProjet.js